import { useState, useEffect } from 'react';
// Comme useState mais persiste en sessionStorage (conservé tant que l'onglet est ouvert,
// survit à la navigation entre écrans + au refresh). Clé unique par usage.
export default function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : defaultValue;
    } catch { return defaultValue; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* quota/private mode */ }
  }, [key, value]);
  return [value, setValue];
}
